// src/routes/supplierRoutes.tsx
import React from "react";
import Labels from "./labels";
import Account from "./account"; // this should point to the account page component
//import { User } from "react-feather";
import { IRoutes } from "../interfaces/route";
import Dashboard from "./newDashboard"; // or ./dashboard if you want the old one
import Ingredients from "./ingredients";
import SupplierSearchIngredients from "./ingredients/supplierSearchIngredients";
import { routes } from "./routes";
import FeatureTeaser from "./feature-teaser/feature-teaser"; // (check actual path)
import guavaLogo from "../assets/images/guava-logo.png";

// import {
// 	Box,
// 	Tag,
// 	Users,
// 	BarChart2,
// 	User,
// 	Share2,
// 	Key,
// 	HelpCircle,
// 	Bell,
// 	File,
// 	ShoppingBag
// } from "react-feather";

import {
	Home, // Dashboard
	Droplet, // Ingredients
	Box, // Products
	ShoppingBag, // Suppliers
	Package, // Packaging
	BarChart2, // Analytics
	Share2, // Integrations
	FileText, // Documents
	User, // Account
	Key, // Admin
	HelpCircle, // Knowledge Hub
	Zap
} from "react-feather";
import { USER_ROLES } from "../interfaces/roles";
import GuavaDashboard from "./supplierDashboard/components/guavaDashboard";
import AIChatDashboard from "./aichat/AIChatDashboard";
// Define supplier-specific routes as an array
export const SupplierRoutes: IRoutes = [
	{
		component: Dashboard,
		path: routes.DASHBOARD,
		name: "Overview",
		icon: <Home size={20} />,
		atBottom: false,
		submenus: []
	},
	{
		component: AIChatDashboard,
		path: routes.AICHATDASHBOARD,
		name: "Generate",
		icon: <Zap size={20} />,
		atBottom: false,
		submenus: []
	},
	{
		path: routes.INGREDIENTS,
		name: "AI Generate",
		icon: <Zap size={20} />,
		component: Ingredients,
		atBottom: false,
		includeSpace: true,
		submenus: [],
		permission_name: "ingredient_engine",
		upgrade_path: routes.INGREDIENTS_TEASER,
		upgrade_component: FeatureTeaser
	},
	{
		path: routes.INGREDIENTS,
		name: "Ingredients",
		icon: "icon-nav-ingredients",
		component: Ingredients,
		atBottom: false,
		includeSpace: true,
		submenus: [
			{
				name: "Search Ingredients",
				route: routes.INGREDIENTS_SEARCH
			}
		],
		permission_name: "ingredient_engine",
		upgrade_path: routes.INGREDIENTS_TEASER,
		upgrade_component: FeatureTeaser
	},
	{
		path: routes.INGREDIENTS_SEARCH,
		name: "Search Ingredients",
		icon: "icon-nav-ingredients",
		component: SupplierSearchIngredients,
		atBottom: false,
		includeSpace: true,
		submenus: [],
		permission_name: "ingredient_engine",
		upgrade_path: routes.INGREDIENTS_TEASER,
		upgrade_component: FeatureTeaser
	},
	{
		path: routes.LABELS,
		name: "Documents",
		icon: <FileText size={28} />,
		component: Labels,
		atBottom: false,
		// roles: [USER_ROLES.COMPANY_ADMIN, USER_ROLES.ADMIN],
		submenus: [],
		upgrade_path: routes.LABELS_TEASER,
		permission_name: "labels_tool",
		upgrade_component: FeatureTeaser
		//locked_for: ["supplier"]
	},
	// {
	// 	path: routes.GUAVA,
	// 	name: "Guava",
	// 	icon: (
	// 		<img
	// 			src={guavaLogo}
	// 			alt="Guava Logo"
	// 			width={24}
	// 			height={24}
	// 			style={{ borderRadius: "50%" }}
	// 		/>
	// 	),
	// 	component: GuavaDashboard,
	// 	atBottom: false,
	// 	includeSpace: true,
	// 	submenus: []
	// },
	{
		path: "/app/account",
		name: "Account",
		icon: <User size={28} />,
		component: Account,
		includeSpace: true,
		atBottom: true,
		submenus: [
			{
				name: "Profile Settings",
				route: routes.PROFILE
			},
			{
				name: "Company Settings",
				route: routes.COMPANY,
				tabRoles: [USER_ROLES.COMPANY_ADMIN, USER_ROLES.COMPANY_USER]
			},
			{
				name: "Preferences",
				route: routes.PREFERENCES,
				tabRoles: [USER_ROLES.COMPANY_ADMIN, USER_ROLES.COMPANY_USER]
			},
			{
				name: "Billing",
				route: routes.BILLING,
				tabRoles: [USER_ROLES.COMPANY_ADMIN]
			}
		]
	}
	// You can keep adding more supplier-specific routes here...
];
